// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"f25511b8","143":"5ee03f30","230":"520e30f6","300":"4c0136ed","514":"ff497d13","828":"412aee5e"}[chunkId] + ".chunk.css";
};